module.exports = __webpack_public_path__ + "static/media/Colette Straight Single Headboard - 90 cm_Beige.a634b1b0.png";